import { Col } from "antd";
import { SkeletonText } from "components/UI/skeletonExport";
import { SkeletonSquare } from "components/UI/skeletonSquare";
import DOMPurify from "dompurify";
import { useRef, useState } from "react";
import backgroud from "../../../../assets/FONDO_DIGITALIZA.jpg";
import { RowLayout } from "./styles";
export const Video = ({
  url = "",
  title = "",
  description = "",
  loading = false,
}) => {
  const videoRef = useRef(null);
  const [showPlay, setShowPlay] = useState(true);
  const [showControls, setShowControls] = useState(false);

  const handlePlay = () => {
    const video = videoRef.current;
    if (video) {
      video.play();
      setShowPlay(false);
      setShowControls(true);
    }
  };
  return (
    <>
      <div id={"iCancha"} />
      <RowLayout image={backgroud}>
        <Col className="COL-video" xs={24} sm={24} md={8} span={8}>
          {loading ? (
            <SkeletonSquare />
          ) : (
            <div
              style={{ position: "relative", width: "100%", height: "100%" }}
            >
              <video
                ref={videoRef}
                style={{ objectFit: "contain", width: "100%", height: "100%" }}
                controls={showControls}
                loop
              >
                <source src={url} type="video/mp4" />
                <source src={url} type="video/quicktime" />
              </video>

              {showPlay && (
                <div
                  onClick={handlePlay}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    fontSize: "60px",
                    color: "white",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    borderRadius: "50%",
                    width: "80px",
                    height: "80px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    zIndex: 1,
                  }}
                >
                  ▶
                </div>
              )}
            </div>
          )}
        </Col>
        <Col className="COL-descriptions" xs={24} sm={24} md={16} span={16}>
          {loading ? (
            <SkeletonText count={2} height={30} />
          ) : (
            <p
              className="title"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(title ?? ""),
              }}
            />
          )}
          {loading ? (
            <div className="text">
              <SkeletonText count={3} height={20} />
              <SkeletonText count={5} height={20} />
            </div>
          ) : (
            <p
              className="description"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(description ?? ""),
              }}
            />
          )}
        </Col>
      </RowLayout>
    </>
  );
};
